// Dependencies:
// - navigator

const { navigator } = window;

const register = () => {
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker.register('/serviceworker.js', { scope: '/' })
      .then(() => {
        console.log('[Page] Service worker registered!'); // eslint-disable-line no-console
      }).catch((error) => {
        console.log(error); // eslint-disable-line no-console
      });
  }
  return Promise.resolve(false);
};

window.fishnet = window.fishnet || {};

window.fishnet.registration = {
  init: register,
};
